import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormViewSet } from '@cer/cer-form/cer-form-view-set';
import { CerFormPanesSettingsUtil } from '@cer/cer-form/cer-form-panes/cer-form-panes.service';
import { CerFormView } from '@cer/cer-form/cer-form-view';
import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';

export class SalesChannelForm extends CerFormAdapter {

  override viewSetInit(viewSet: CerFormViewSet): void {
    viewSet.panes = CerFormPanesSettingsUtil.masterDetail('horizontal', true, 25);
    const view = SalesChannelForm.viewGet();
    viewSet.viewAdd(view);
    const viewProducts = SalesChannelForm.viewProductsGet();
    viewSet.viewAdd(viewProducts, view);
  }

  public static viewGet(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'salg-kanaler', dataApiName: 'SalesChannel', text: 'Salgskanaler', textSingular: 'Salgskanal',
        primaryKey: 'num', baseFields: ['id', 'num', 'name', 'history']
      },

      fieldMetadata: [
        { name: 'orderType', text: 'Ordretype salg', foreignKeyTableName: 'SalesOrderType', foreignKeyField: 'num' },
        { name: 'orderNumFormat', text: 'Ordrenr. format salg' },
        { name: 'orderNumIntNext', text: 'Ordrenr. næste salg', format: 'Number' },
        { name: 'orderNumIntNextCompleted', text: 'Ordrenr. seneste afsluttet', format: 'Number' },
        { name: 'orderMaintenance', text: 'Adgang salgsordre', foreignKeyTableName: 'DataLogActionType' },
        { name: 'warehouseOutboundOrderType', text: 'Lager udg. ordre', foreignKeyTableName: 'WarehouseOutboundOrderType', foreignKeyField: 'num' },
        { name: 'synced', text: 'Synkoniseret', format: 'DateLong' }
      ]
    });
  }

  public static viewProductsGet(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'salg-kanal-produkter', dataApiName: 'SalesChannelProduct', text: 'Salgskanal produkter',
        primaryKey: 'id', parentPrimaryKey: 'num', parentForeignKey: 'salesChannel',
        baseFields: ['id', 'history'], titleFields: ['num', 'product', 'name']
      },
      fieldMetadata: [
        { name: 'salesChannel', text: 'Salgskanal', foreignKeyTableName: 'SalesChannel', foreignKeyField: 'num', visible: false, widthType: FieldWidthEnum.M },
        { name: 'num', text: 'Varenr.', tooltipText: 'Varenr. i salgskanalen', required: true, widthType: FieldWidthEnum.S },
        { name: 'product', text: 'ISBN', required: true, fieldType: 'product', widthType: FieldWidthEnum.M },
        { name: 'name', text: 'Navn', widthType: FieldWidthEnum.M },
        { name: 'convertQtyFactor', text: 'Faktor', tooltipText: 'Omregningsfaktor for antal', defaultValue: 1, format: 'Number', required: true, widthType: FieldWidthEnum.XXS },
        { name: 'convertBOM', text: 'Omregning via bogpakke', defaultValue: 1, format: 'CheckBox', required: true, widthType: FieldWidthEnum.XXS }
      ]
    });
  }
}
